import { OnInit, OnDestroy, AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  template: ``,
})
export abstract class FpxBaseShellComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  //@ViewChild() embeddableForm:IEmbeddableForm;

  private _router: Router;

  constructor(router: Router) {
    this._router = router;
  }

  ngOnInit(): void {}
  ngOnDestroy(): void {}
  ngAfterViewInit(): void {}

  public navigateToForm(path: String) {
    this._router.navigate(path.split('/'));
  }
}

export class FpxViewShellComponent extends FpxBaseShellComponent {
  onBack() {}
}

export class FpxRepairShellComponent extends FpxBaseShellComponent {
  onResubmit() {}
  onBack() {}
  onRevert() {}
}

export class FpxApprovalShellComponent extends FpxBaseShellComponent {
  onApprove() {}
  onReject() {}
  onCancel() {}
  onDelegate() {}
}
